<template>
    <div class="msg-wrapper">
        <div class="msg-placeholder">
        </div>
        <div class="msg-content-box user-msg-box">
            <div class="user-msg">
                <v-md-preview :text="data.content"></v-md-preview>
                <div class="user-msg-misc flex-center-hori">
                    <div class="misc-content"></div>
                    <div class="feedback-display">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                            <i class="ecp-iconfont ecp-icon-copy" @click="copyToClipboard(data.content)" />
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重新提问" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                            <i class="el-icon-refresh" @click="askAgain(data.content)" />
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <div class="msg-placeholder">
            <img class="user-avatar">
            <el-popover v-if="$store.state.appSettings.isDebug" trigger="click" placement="right">
                <!--调试信息-->
                <el-link slot="reference" :underline="false"><i class="el-icon-magic-stick"/></el-link>
                <pre style="font-size:12px; color: #999; max-width: 60em; max-height: 40em; overflow: auto;">{{data.notShowContent || data.content}}</pre>
            </el-popover>
        </div>
    </div>
</template>
<script>
import copyToClipboard from 'copy-to-clipboard';
export default {
    name: 'MsgUserAsk',
    props: [ 'data' ],
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    methods: {
        /**
         * 复制到剪贴板
         */
        copyToClipboard (text) {
            copyToClipboard(text);
            this.$message.success('内容已复制到剪贴板');
        },

        /**
         * 重新提问
         */
        askAgain (text) {
            this.$emit('askAgain', text);
        }
    }
};
</script>
<style scoped lang="scss">
.user-msg-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
}

.user-msg {
    box-sizing: border-box;
    width: auto;
    min-width: 50%;
    max-width: 100%;
    background-color: var(--msg-user-bg);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 10px 16px;

    font-size: 16px;
    color: var(--msg-common-text-color);
    line-height: 24px;
    overflow-wrap: break-word;
}

.user-msg-misc {
    box-sizing: border-box;
    width: 100%;
    border-top: 1px solid var(--shortcuts-border);
    padding-top: 12px;
    line-height: 24px;

    .misc-content {
        flex: 1 1 auto;
    }

    .stop-generating {
        font-size: 12px;
        color: var(--msg-common-text-color);
        opacity: 0.4;
        cursor: pointer;
        display: flex;
        align-items: center;

        i {
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;
        }
    }

    .misc-control {
        flex: 0 0 auto;

        img {
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;
        }

        i {
            margin: 0 2px;
            margin-top: 0;
            line-height: 22px;
        }
    }
    .play-control,
    .feedback-display,
    .feedback-control {
        flex: 0 0 auto;
        i {
            cursor: pointer;
            font-size: 20px;
            opacity: 0.5;
            &:hover {
                opacity: 1;
            }
        }
    }

    .feedback-display {
        .good {
            cursor: unset;
            opacity: 1;
            color: #126CFF;
        }
        .bad {
            cursor: unset;
            opacity: 1;
            color: #ff1212;
        }
    }
}

.msg-placeholder {
    text-align: center;
}

.user-avatar{
    content: var(--user-avatar);
}

</style>
